<template>
    <div class="d-flex justify-content-start mb-4">
        <core-lever
            class="col-sm-4 px-0 currency input-group d-flex justify-content-between align-items-center"
            :label="$t('components.price.element.breakfast.label')"
            v-model="includeBreakfast"
            labelClass="px-2"
        ></core-lever>
    </div>
</template>

<script>
export default {
  data () {
    return {
      includeBreakfast: parseInt(this.breakfast) || 0
    }
  },
  props: {
    breakfast: {
      default: 1,
      type: String | Number,
      required: false
    }
  },
  watch: {
    includeBreakfast (val) {
      this.$emit('update:breakfast', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/price/element/Breakfast.vue